export const DEVICES_EVENTS = {
  ACC_ON: 'accOn',
  ACC_OFF: 'accOff'
}
